import { Component } from '@angular/core'

@Component({
  template: '<ftr-supported-browsers></ftr-supported-browsers>',
  standalone: false,
})
export class SupportedBrowsersPage {}
